// Splits a Contentful long text field into paragraphs at blank lines.
export const toParagraphs = text =>
  (text || "")
    .split(/\n\s*\n/)
    .map(paragraph => paragraph.trim())
    .filter(Boolean)
